/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseGalleryImage } from '../../models/response-gallery-image';

export interface CreateActivityGalleryImage$Params {

/**
 * ID of activity to which add gallery image.
 */
  id: number;
      body: {
'file': Blob;
}
}

export function createActivityGalleryImage(http: HttpClient, rootUrl: string, params: CreateActivityGalleryImage$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseGalleryImage>> {
  const rb = new RequestBuilder(rootUrl, createActivityGalleryImage.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseGalleryImage>;
    })
  );
}

createActivityGalleryImage.PATH = '/rest/activity/{id}/gallery';
